module.exports = __webpack_public_path__ + "static/CircularStd-Bold-334c5f669cbd77d60393fe3250bf780c.ttf";